import React from "react";

const BillContext = React.createContext();

export const BillProvider = BillContext.Provider;
export const BillConsumer = BillContext.Consumer;
export default BillContext;
